import React from 'react';
import { Button } from 'react-admin';
import { download } from './download';

export const PDFInvoiceButton = (props) => {
  return (
    <Button
      label="Счет-фактура в PDF"
      onClick={() => download(props.record.id, 'generate')}
    />
  );
};
